/*
 * Copyright (c) Kalaora 2022.
 * Author: fharold
 *
 * hilo-oauth-manager
 * Forbidden.ts
 */

import APIError from "./APIError";

export default class Forbidden extends APIError {
    constructor(message: string) {
        super("Ressource interdite", 403, message);
    }
}